import { Link } from 'react-router-dom';
import { BRAND_MARK_URL, BRAND_TAGLINE, BRAND_NAVY, BRAND_SKY } from '../components/Logo';

/**
 * The signed-out front page. Deliberately plain: SchoolOne is sold directly
 * to a small number of schools, so this page exists to get staff to the sign-in
 * and to give visitors the legal and contact links — nothing more.
 */
export default function LandingPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white text-gray-900">
      <main className="flex flex-1 flex-col items-center justify-center px-6 py-24 text-center">
        <img src={BRAND_MARK_URL} alt="" aria-hidden="true" className="h-24 w-24 object-contain" />
        <h1 className="mt-4 text-4xl font-bold tracking-tight" aria-label="SchoolOne">
          <span style={{ color: BRAND_NAVY }}>School</span>
          <span style={{ color: BRAND_SKY }}>One</span>
        </h1>
        <p className="mt-3 max-w-md text-base text-gray-600">{BRAND_TAGLINE}</p>
        <Link
          to="/login"
          className="mt-8 inline-flex items-center justify-center rounded-md bg-brand-600 px-6 py-3 text-base font-semibold text-white transition-colors hover:bg-brand-700"
        >
          Sign in
        </Link>
        <p className="mt-6 text-sm text-gray-500">
          Questions?{' '}
          <a href="mailto:hello@schoolone.co.uk" className="text-brand-600 hover:underline">
            hello@schoolone.co.uk
          </a>
        </p>
      </main>

      <footer className="border-t border-gray-200 py-6">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-center gap-x-5 gap-y-2 px-6 text-sm text-gray-500">
          <span>© {new Date().getFullYear()} SchoolOne</span>
          <Link to="/data-security" className="hover:text-brand-600 hover:underline">
            Data &amp; Security
          </Link>
          <Link to="/privacy" className="hover:text-brand-600 hover:underline">
            Privacy
          </Link>
          <Link to="/cookies" className="hover:text-brand-600 hover:underline">
            Cookies
          </Link>
          <Link to="/faq" className="hover:text-brand-600 hover:underline">
            FAQ
          </Link>
        </div>
      </footer>
    </div>
  );
}
